import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let defaultCity = {
    province: "广东省",
    city: "东莞",
    district: "南城区",
    lat: 22.9981,
    lng: 113.73377
}

try {
    if (localStorage.city_data) {
        defaultCity = JSON.parse(localStorage.getItem('city_data'))
    }
}catch (e) {}

import home from './module/home'
import login from './module/login'
import user from './module/user'
import article from './module/article'
import shop from './module/shop'
import expert from './module/expert'
import cases from './module/cases'
import common from './module/common'
import info from './module/info'
import win from './module/win'
import report from './module/report'

export default new Vuex.Store({
    state: {
        cityData: defaultCity,
        currentCity:localStorage.getItem('current_city') ? localStorage.getItem('current_city') : '东莞',
        cityLocation: localStorage.getItem('city_location') ? localStorage.getItem('city_location') : false
    },
    mutations: {
        UPDATE_CHANGE_CITY(state,cityData) {
            state.cityData = cityData
            try {
                localStorage.city_data = city_data
            }catch (e) {}
        },
        UPDATE_CITY_LOCATION(state,payload) {
            state.cityLocation = payload
        },
        UPDATE_CURRENT_CITY(state,payload) {
            state.currentCity = payload
        }
    },
    modules: {
        root: home,
        login: login,
        user: user,
        article: article,
        shop: shop,
        expert: expert,
        cases: cases,
        common: common,
        info: info,
        win: win,
        report: report
    }
})
